import AttendanceStatsApi from '../../services/rest/AttendanceStats';

export const LOAD_ATTENDANCE_STATS_REQUEST = 'LOAD_ATTENDANCE_STATS_REQUEST';
export const LOAD_ATTENDANCE_STATS_SUCCESS = 'LOAD_ATTENDANCE_STATS_SUCCESS';
export const LOAD_ATTENDANCE_STATS_FAILURE = 'LOAD_ATTENDANCE_STATS_FAILURE';

export const loadAttendanceStatsRequest = (hash) => ({ type: LOAD_ATTENDANCE_STATS_REQUEST, hash });
export const loadAttendanceStatsSuccess = (hash, data) => ({ type: LOAD_ATTENDANCE_STATS_SUCCESS, data, hash });
export const loadAttendanceStatsFailure = (hash, error) => ({ type: LOAD_ATTENDANCE_STATS_FAILURE, error, hash });

const initStatsState = () => ({
    isLoading: true,
    error: null,
    data: null
});

const initialState = {
    isLoading: false,
    stats: {}
};

export default function attendanceStats(state = initialState, action) {
    switch (action.type) {
        case LOAD_ATTENDANCE_STATS_REQUEST:
            return {
                ...state,
                stats: {
                    ...state.stats,
                    [action.hash]: initStatsState()
                }
            };
        case LOAD_ATTENDANCE_STATS_SUCCESS:
            return {
                ...state,
                stats: {
                    ...state.stats,
                    [action.hash]: {
                        ...state.stats[action.hash],
                        data: action.data,
                        isLoading: false,
                    }
                }
            };
        case LOAD_ATTENDANCE_STATS_FAILURE:
            return {
                ...state,
                stats: {
                    ...state.stats,
                    [action.hash]: {
                        ...state.stats[action.hash],
                        error: action.error,
                        isLoading: false,
                    }
                },
            };
        default:
            return state;
    }
}

export const loadAttendanceStats = (hash, filters) => {
    return async (dispatch) => {
        dispatch(loadAttendanceStatsRequest(hash));
        try {
            const data = await AttendanceStatsApi.getStats(filters);
            dispatch(loadAttendanceStatsSuccess(hash, data.stats));
            return data;
        } catch (error) {
            dispatch(loadAttendanceStatsFailure(hash, error.message || 'Failed to load attendance stats'));
            return null;
        }
    };
};
